export const defaultNodeProps = [
  {
    type: "checkbox",
    label: "Outlet",
    value: false,
    key: "outlet_candidate",
  },
  // "Existing Manhole" and "Lift station" are deactivated: they stay false by
  // default and are not exposed in the UI (see NodeProperties, where they are
  // filtered out). Lift stations are determined solely by the optimization,
  // and the backend defaults both flags to False when they are absent.
];
